// extracted by mini-css-extract-plugin
module.exports = {"link":"metodo-module--link--2WI6u"};